import { createSlice } from "@reduxjs/toolkit";
import { fetchInit } from "../user/userSlice";

const footerSlice = createSlice({
    name: 'footer',
    initialState: {
        address: "",
        contactEmail: "",
        serviceEmail: "",
        financialEmail: "",
        sellers: {},
        service: {},
        importantLinks: {}
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchInit.fulfilled, (state, action) => {
                state.address = action.payload.footer.address
                state.contactEmail = action.payload.footer.contactEmail
                state.serviceEmail = action.payload.footer.serviceEmail
                state.financialEmail = action.payload.footer.financialEmail
                state.sellers = action.payload.footer.sellers
                state.service = action.payload.footer.service
                state.importantLinks = action.payload.footer.importantLinks
            })
    }
})
export default footerSlice.reducer;